export default __webpack_public_path__ + "static/media/store.3fa9a2c9.svg";